/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Directory_Detail_More_In_CategoryInputs */

const en_directory_detail_more_in_category = /** @type {(inputs: Directory_Detail_More_In_CategoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More in ${i?.category}`)
};

const zh_directory_detail_more_in_category = /** @type {(inputs: Directory_Detail_More_In_CategoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更多 ${i?.category} 工具`)
};

/**
* | output |
* | --- |
* | "More in {category}" |
*
* @param {Directory_Detail_More_In_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_more_in_category = /** @type {((inputs: Directory_Detail_More_In_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_More_In_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_more_in_category(inputs)
	return zh_directory_detail_more_in_category(inputs)
});
export { directory_detail_more_in_category as "directory.detail.more_in_category" }